// import React from "react";
// import {
//   PDFDownloadLink,
//   Document,
//   Page,
//   View,
//   StyleSheet,
//   Text,
//   Link,
//   Image,
// } from "@react-pdf/renderer";
// import { useSelector } from "react-redux";
// // import slsLogo from "../../../assets/images/loanlinq.png";

// const getPath = () => {
//   // Check if the current URL contains 'uat'
//   if (window.location.href.toLowerCase().includes("localhost")) {
//     return "http://localhost:3000/assets/loanlinq.png";
//   } else if (window.location.href.toLowerCase().includes("uat")) {
//     return "https://uat.loanlinq.com/assets/loanlinq.png";
//   } else if (window.location.href.toLowerCase().includes("loanlinq.com")) {
//     return "https://loanlinq.com/assets/loanlinq.png";
//   }
// };

// function PdfGenerator({ title, col, row, totalSectionArr }) {
//   const logoPath = getPath();
//   const selectedAccount = useSelector((state) => state.account.selectedAccount);
//   const styles = StyleSheet.create({
//     page: {
//       flexDirection: "row",
//       backgroundColor: "#ffffff",
//     },
//     section: {
//       margin: 10,
//       padding: 10,
//       flexGrow: 1,
//     },
//     mainImage: {
//       display: "flex",
//       width: "100%",
//       justifyContent: "center",
//       alignItems: "center",
//     },
//     mainHeading: {
//       display: "flex",
//       width: "100%",
//       justifyContent: "center",
//       alignItems: "center",
//       margin: "10px",
//     },
//     heading: {
//       margin: "20px",
//     },
//     table: {
//       display: "table",
//       width: "auto",
//     },
//     tableRow: {
//       margin: "auto",
//       flexDirection: "row",
//       alignItems: "stretch",
//       // height: "70px",
//     },
//     tableHead: {
//       width: `${100 / col?.length}%` || "25%",
//       borderBottom: "1px solid #efefef",
//       color: "#7f8da2",
//       backgroundColor: "#fbfbfb",
//     },
//     tableCol: {
//       width: `${100 / col?.length}%` || "25%",
//       borderBottom: "1px solid #efefef",
//     },
//     tableCell: {
//       margin: 5,
//       padding: 10,
//       fontSize: 11,
//       fontWeight: 400,
//       wordBreak: "break-word",
//     },
//   });

//   return (
//     <div>
//       <PDFDownloadLink
//         document={
//           <Document>
//             <Page size="A3" style={styles.page} wrap>
//               <View style={styles.section}>
//                 <View style={styles.mainImage}>
//                   <Image src={logoPath} />
//                 </View>
//                 <View style={styles.mainHeading}>
//                   <Text>
//                     {selectedAccount?.label} | Superior Loan Servicing
//                   </Text>
//                 </View>
//                 <Text style={styles.heading}>{title}</Text>
//                 <View style={styles.table}>
//                   <TableRow data={col} isHead styles={styles} />
//                   {row.map((rowData, index) => (
//                     <TableRow key={index} data={rowData} styles={styles} />
//                   ))}
//                   <TableRow data={totalSectionArr} isHead styles={styles} />
//                 </View>
//               </View>
//             </Page>
//           </Document>
//         }
//         fileName={`${title}.pdf`}
//       >
//         {({ blob, url, loading, error }) =>
//           loading ? "Generating PDF..." : "Download PDF"
//         }
//       </PDFDownloadLink>
//     </div>
//   );
// }

// export default PdfGenerator;
// const TableRow = ({ data, isHead = false, styles }) => {
//   // Instead of an array, create a single style object for each cell
//   const cellStyles = (cellData) =>
//     isHead
//       ? { ...styles.tableHead, width: `${100 / data?.length}%` }
//       : { ...styles.tableCol, width: `${100 / data?.length}%` };

//   return (
//     <View style={styles.tableRow} wrap={false}>
//       {data.map((cell, index) => (
//         <View key={index} style={cellStyles(cell)}>
//           {typeof cell === "object" && cell ? (
//             <Text>
//               <Link style={styles.tableCell} src={cell.href}>
//                 {cell.title}
//               </Link>
//             </Text>
//           ) : (
//             <Text style={styles.tableCell}>{cell}</Text>
//           )}
//         </View>
//       ))}
//     </View>
//   );
// };

import React, { useRef, useState } from "react";
import { useGrid } from "../../../context/GridContext";

const PdfGenerator = ({
  col,
  row,
  totalSectionArr,
  logoBase64,
  title,
  selectedAccount,
  isBroadviewAccount,
}) => {
  const [pdfURL, setPdfURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const workerRef = useRef();
  const { reportLenders } = useGrid();

  const handleClick = () => {
    setLoading(true);

    if (workerRef.current) {
      workerRef.current.terminate();
    }

    workerRef.current = new Worker(new URL("./pdf.worker.js", import.meta.url));

    workerRef.current.onmessage = (e) => {
      const blob = e.data.blob;
      const url = URL.createObjectURL(blob);
      setPdfURL(url);
      setLoading(false);
    };

    try {
      const payload = {
        col: stripFunctions(col),
        row: stripFunctions(row),
        totalSectionArr,
        title,
        logoBase64,
        accountLabel: reportLenders
          ? reportLenders?.length > 2
            ? "Multiple Accounts"
            : reportLenders.map((el) => el.label).join(", ")
          : selectedAccount?.label || "Account",
        isBroadviewAccount,
      };

      workerRef.current.postMessage(payload);
    } catch (error) {
      console.error("Failed to send to worker:", error);
      setLoading(false);
    }
  };

  return (
    <div>
      {!pdfURL ? (
        <p
          role="button"
          className="linkClick cursor-pointer text-decoration-underline"
          onClick={handleClick}
        >
          {loading ? "Generating..." : "Generate PDF"}
        </p>
      ) : (
        <a href={pdfURL} download={`${title}.pdf`}>
          Download PDF
        </a>
      )}
      {/* <button onClick={handleClick}>Generate PDF</button>
      {pdfURL && (
        <a href={pdfURL} download={`${title}.pdf`}>
          Download PDF
        </a>
      )} */}
    </div>
  );
};

export default PdfGenerator;

const stripFunctions = (data) =>
  JSON.parse(
    JSON.stringify(data, (key, value) => {
      if (typeof value === "function") return undefined;
      if (React.isValidElement(value)) return undefined;
      return value;
    })
  );
